import moment from "moment";

const mapMemberRevenueData = (datas) => {
  return !datas
    ? []
    : datas.map((t) => {
        //const dateTime = getDateTimeFormat(new Date(t.time), periodType);
        return {
          Date: t.time,
          Name: t.firstname ? `${t.firstname} ${t.lastname}` : "Walk-in",

          Transactions: t.payment.total_transaction,
          "Quantity (Units)": t.payment.total_qty,
          "Total Price": t.payment.total_payment,
          Discount: Math.abs(t.payment.total_discount),
          "Total Revenue": t.payment.total_revenue,
          Cash: t.life_time?.total_payment_method?.Cash?.total_amount ?? 0,
          Transfer:
            t.life_time?.total_payment_method?.Transfer?.total_amount ?? 0,
          "Credit/Debit":
            t.life_time?.total_payment_method?.["Credit-Debit"]?.total_amount ??
            0,
        };
      });
};

const mapGuestRevenueData = (datas) => {
  return !datas
    ? []
    : datas.map((t) => {
        //const dateTime = getDateTimeFormat(new Date(t.time), periodType);
        return {
          Date: t.time,
          Name: "Walk-in",

          Transactions: t.payment.total_transaction,
          "Quantity (Units)": t.payment.total_qty,
          "Total Price": t.payment.total_payment,
          Discount: Math.abs(t.payment.total_discount),
          "Total Revenue": t.payment.total_revenue,
          Cash: t.life_time?.total_payment_method?.Cash?.total_amount ?? 0,
          Transfer:
            t.life_time?.total_payment_method?.Transfer?.total_amount ?? 0,
          "Credit/Debit":
            t.life_time?.total_payment_method?.["Credit-Debit"]?.total_amount ??
            0,
        };
      });
};

const mapTransactionData = (datas) => {
  const findSumPaymentChannel = (type, datas) => {
    if (!datas) return 0;
    const payChannels = datas.filter((p) => p.type === type);
    if (!payChannels || payChannels.length === 0) return 0;
    return payChannels.reduce((total, p) => Number(p.amount) + total, 0);
  };

  return !datas
    ? []
    : datas.map((t) => {
        //const dateTime = getDateTimeFormat(new Date(t.time), periodType);
        return {
          Date: moment(
            t.create_local_time?.split(".")[0],
            "YYYY-MM-DD HH:mm:ss"
          ),
          "Name and Payment ID": !t.member.firstname
            ? `Walk-in\n ${t.transaction_no}`
            : `${t.member.firstname} ${t.member.lastname}\n ${t.transaction_no}`,
          "Quantity (Units)": t.total_qty ?? 0,
          "Total Price": t.total_payment ?? 0,
          Discount: Math.abs(t.total_discount ?? 0),
          "Total Payment": t.total_revenue ?? 0,
          Cash: findSumPaymentChannel("Cash", t.payment_channels),
          Transfer: findSumPaymentChannel("Transfer", t.payment_channels),
          "Credit/Debit": findSumPaymentChannel(
            "Credit-Debit",
            t.payment_channels
          ),
        };
      });
};

const mapVoidTransactionData = (datas, periodType = "Day") => {
  const findPaymentMethod = (datas) => {
    const result = [];
    datas.forEach((data) => {
      if (data.amount > 0) result.push(data.type);
    });
    return result.join(",");
  };

  return !datas
    ? []
    : datas.map((t) => {
        //const dateTime = getDateTimeFormat(new Date(t.time), periodType);
        console.log(JSON.stringify(t));
        return {
          Date: moment(t.void_time),
          "Name and Payment ID": !t.member.firstname
            ? `Walk-in\n ${t.transaction_no}`
            : `${t.member.firstname} ${t.member.lastname}\n ${t.transaction_no}`,
          "Total Revenue": t.total_revenue ?? 0,
          "Payment Method": findPaymentMethod(t.payment_channels),
          User: t.void_by_id,
          Remark: t.void_remark,
        };
      });
};

const makeSummary = (datas) => {
  return datas.reduce(
    (total, row) => {
      return {
        Date: "Total",
        Name: "",

        Transactions: (row["Transactions"] ?? 0) + total["Transactions"],
        "Quantity (Units)":
          (row["Quantity (Units)"] ?? 0) + total["Quantity (Units)"],
        "Total Price": (row["Total Price"] ?? 0) + total["Total Price"],
        Discount: (row["Discount"] ?? 0) + total["Discount"],
        "Total Revenue": (row["Total Revenue"] ?? 0) + total["Total Revenue"],
        Cash: (row["Cash"] ?? 0) + total["Cash"],
        Transfer: (row["Transfer"] ?? 0) + total["Transfer"],
        "Credit/Debit": (row["Credit/Debit"] ?? 0) + total["Credit/Debit"],
      };
    },
    {
      Date: "Total",
      Name: "",

      Transactions: 0,
      "Quantity (Units)": 0,
      "Total Price": 0,
      Discount: 0,
      "Total Revenue": 0,
      Cash: 0,
      Transfer: 0,
      "Credit/Debit": 0,
    }
  );
};
const makeGuestSummary = (datas) => {
  return datas.reduce(
    (total, row) => {
      return {
        Date: "Total",
        Name: "",

        Transactions: row["Transactions"] + total["Transactions"],
        "Quantity (Units)": row["Quantity (Units)"] + total["Quantity (Units)"],
        "Total Price": row["Total Price"] + total["Total Price"],
        Discount: row["Discount"] + total["Discount"],
        "Total Revenue": row["Total Revenue"] + total["Total Revenue"],
        Cash: row["Cash"] + total["Cash"],
        Transfer: row["Transfer"] + total["Transfer"],
        "Credit/Debit": row["Credit/Debit"] + total["Credit/Debit"],
      };
    },
    {
      Date: "Total",
      Name: "",
      Transactions: 0,
      "Quantity (Units)": 0,
      "Total Price": 0,
      Discount: 0,
      "Total Revenue": 0,
      Cash: 0,
      Transfer: 0,
      "Credit/Debit": 0,
    }
  );
};

const makeTransactionsSummary = (datas) => {
  return datas.reduce(
    (total, row) => {
      return {
        Date: "Total",
        "Name and Payment ID": "",
        "Quantity (Units)": row["Quantity (Units)"] + total["Quantity (Units)"],
        "Total Price": row["Total Price"] + total["Total Price"],
        Discount: row["Discount"] + total["Discount"],
        "Total Payment": row["Total Payment"] + total["Total Payment"],
        Cash: row["Cash"] + total["Cash"],
        Transfer: row["Transfer"] + total["Transfer"],
        "Credit/Debit": row["Credit/Debit"] + total["Credit/Debit"],
      };
    },
    {
      Date: "Total",
      "Name and Payment ID": "",
      "Quantity (Units)": 0,
      "Total Price": 0,
      Discount: 0,
      "Total Payment": 0,
      Cash: 0,
      Transfer: 0,
      "Credit/Debit": 0,
    }
  );
};

const makeVoidTransactionsSummary = (datas) => {
  return datas.reduce(
    (total, row) => {
      return {
        Date: "Total",
        "Name and Payment ID": "",
        "Total Revenue": row["Total Revenue"] + total["Total Revenue"],
        "Payment Method": "",
        User: "",
        Remark: "",
      };
    },
    {
      Date: "Total",
      "Name and Payment ID": "",
      "Total Revenue": 0,
      "Payment Method": "",
      User: "",
      Remark: "",
    }
  );
};

export {
  mapMemberRevenueData,
  mapGuestRevenueData,
  mapTransactionData,
  mapVoidTransactionData,
  makeSummary,
  makeGuestSummary,
  makeTransactionsSummary,
  makeVoidTransactionsSummary,
};
